import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
  disabledColor?: string;
};

const IconEmail: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#FFFFFF',
  disabled = false,
  disabledColor = '#999999',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 17.2916H5C2.985 17.2916 1.875 16.1816 1.875 14.1666V6.66663C1.875 4.65163 2.985 3.54163 5 3.54163H15C17.015 3.54163 18.125 4.65163 18.125 6.66663V14.1666C18.125 16.1816 17.015 17.2916 15 17.2916ZM5 4.79163C3.68583 4.79163 3.125 5.35246 3.125 6.66663V14.1666C3.125 15.4808 3.68583 16.0416 5 16.0416H15C16.3142 16.0416 16.875 15.4808 16.875 14.1666V6.66663C16.875 5.35246 16.3142 4.79163 15 4.79163H5ZM10.8575 10.9825L14.9508 8.00579C15.2299 7.80329 15.2916 7.41163 15.0883 7.13246C14.8858 6.85413 14.4959 6.79079 14.2151 6.99496L10.1217 9.97163C10.0483 10.025 9.95086 10.025 9.87752 9.97163L5.7841 6.99496C5.50243 6.79079 5.11339 6.85496 4.91089 7.13246C4.70756 7.41163 4.76925 7.80245 5.04842 8.00579L9.14164 10.9833C9.39831 11.17 9.69919 11.2625 9.99919 11.2625C10.2992 11.2625 10.6017 11.1691 10.8575 10.9825Z"
      fill={disabled ? disabledColor : color}
    />
  </svg>
);

export default IconEmail;
